import Joi from 'joi';

const baseSchema = {
  timeZone: Joi.string().required(),
  cafeName: Joi.string().required(),
  cafeEmail: Joi.string()
    .email({ minDomainSegments: 2, tlds: { allow: ['com', 'net'] } })
    .optional(),
  cafePhone: Joi.string().required(),
  attachmentData: Joi.array().items(Joi.object()).required(),
  streetNumber: Joi.string().required(),
  streetName: Joi.string().required(),
  city: Joi.string().required(),
  country: Joi.string().required(),
  postcode: Joi.string().required(),
  state: Joi.string().required(),
  isDeleted: Joi.boolean().required(),
  Mon: Joi.object().required(),
  Tue: Joi.object().required(),
  Wed: Joi.object().required(),
  Thu: Joi.object().required(),
  Fri: Joi.object().required(),
  Sat: Joi.object().required(),
  Sun: Joi.object().required(),
};

export const cafeSchema = Joi.object({
  ...baseSchema,
});
